/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Anton Panasenko
 * @author Maxim Fedorov
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { EColumnBalance } from '@components/Table/types/columnTypes';
import { colors, fonts } from '@theme/index';

import type { IStyledProps } from '../TableBalanceBlock/TableBalanceBlock';

const TableBalanceValueStyled = styled.span.attrs({
    className: 'table__balance-value',
}) <IStyledProps>`
    ${fonts.textMain};
    ${(props) => (
        props.balanceType === EColumnBalance.positive ? `color: ${colors.tableCellTextColorSuccess}` :
            props.balanceType === EColumnBalance.negative ? `color: ${colors.tableCellTextColorDanger}` : ''
    )}
`;

const TableBalanceCurrencyStyled = styled.span.attrs({
    className: 'table__balance-currency',
})`
    ${fonts.textMain};
    color: ${colors.tableCellTextColorSecondary};
`;

const TableBalanceDateStyled = styled.span.attrs({
    className: 'table__balance-date table__tooltip-text',
})`
    display: inline-block;
    ${fonts.textSmall};
    color: ${colors.tableCellTextColorSecondary};
`;

export {
    TableBalanceCurrencyStyled,
    TableBalanceDateStyled,
    TableBalanceValueStyled,
};
